export const getServicePowerMappings = (errorCode: string | number | undefined) => {
  const servicePowerMappings = {
    PostCodeUnavailable: 'The Postcode for this booking is missing from Service Power',
    NoTimeAvailable: 'There is no available time for this booking',
    NoCoverage: 'There is no Stark engineer coverage for this site between the Job Start and End Dates requests',
    MissingPostCode: 'The Postcode of the Site the Appointment is not set up in the Stark Scheduling Solution',
    Default: 'There was an error with this request, please try again'
  };
  switch (String(errorCode)) {
    case '3':
      return servicePowerMappings.PostCodeUnavailable;
    case '8':
      return servicePowerMappings.NoTimeAvailable;
    case '75':
      return servicePowerMappings.NoCoverage;
    case '156':
      return servicePowerMappings.NoCoverage;
    case '179':
      return servicePowerMappings.MissingPostCode;
    default:
      return servicePowerMappings.Default;
  }
};
